import { fetchGet, fetchPut, jsonToQueryParam } from "./CommonServiceUtils";
import { Constants } from "@/constants";
import {
  TOrganizationGetResponse,
  TOrganizationListGetResponse,
  TOrganizationSearchResponse,
  TOrganizationUpdateRequest,
  TOrganizationUpdateResponse,
  TOrganizationListCountResponse
} from "@shoutout-labs/market_buzz_crm_types";

// New onboarding progress types
export interface OnboardingProgress {
  customer: "IN_PROGRESS" | "DONE";
  customersReportOverview: "IN_PROGRESS" | "DONE";
  smsCampaigns: "IN_PROGRESS" | "DONE";
  productCatalog: "IN_PROGRESS" | "DONE";
  transactions: "IN_PROGRESS" | "DONE";
  transactionReportOverview: "IN_PROGRESS" | "DONE";
  automatedCampaigns: "IN_PROGRESS" | "DONE";
  behaviorAndEngagementReport: "IN_PROGRESS" | "DONE";
  purchasePatternReport: "IN_PROGRESS" | "DONE";
  salesReportOverview: "IN_PROGRESS" | "DONE";
  trendsAndPatternsReport: "IN_PROGRESS" | "DONE";
  productInsightsReport: "IN_PROGRESS" | "DONE";
}

// Onboarding survey data
export interface OnboardingSurvey {
  howDidYouHear?: string;
  lookingToDo?: string;
  mobileNumber?: string;
}

export interface OnboardingUpdateRequest {
  shortName?: string;
  showOnboardingFlow?: boolean;
  onboardingProgress?: Partial<OnboardingProgress>;
  onboardingSurvey?: OnboardingSurvey;
}

export interface OnboardingUpdateResponse {
  shortName: string;
  showOnboardingFlow: boolean;
  onboardingProgress: OnboardingProgress;
}

const getOragnizationData = (): Promise<TOrganizationGetResponse> => {
  return fetchGet(`${Constants.REACT_APP_API_BASE_URL}organizations`);
};

const updateOrganization = async (
  payload: TOrganizationUpdateRequest
): Promise<TOrganizationUpdateResponse> => {
  return await fetchPut(
    `${Constants.REACT_APP_API_BASE_URL}organizations`,
    payload
  );
};

const getOragnizations = (
  skip: number = 0,
  limit: number = 10
): Promise<TOrganizationListGetResponse> => {
  return fetchGet(
    `${Constants.REACT_APP_API_BASE_URL}organizations/list?skip=${skip}&limit=${limit}`
  );
};

const searchOragnizations = (
  queryObj: object
): Promise<TOrganizationSearchResponse> => {
  return fetchGet(
    `${Constants.REACT_APP_API_BASE_URL}organizations/searchOrganization?${jsonToQueryParam(queryObj)}`
  );
};

const filterOragnizations = (
  queryObj: object
): Promise<TOrganizationSearchResponse> => {
  return fetchGet(
    `${Constants.REACT_APP_API_BASE_URL}organizations/filter?${jsonToQueryParam(queryObj)}`
  );
};

const getOrganizationsCount = (): Promise<TOrganizationListCountResponse> => {
  return fetchGet(`${Constants.REACT_APP_API_BASE_URL}organizations/count`);
};

export {
  getOragnizationData,
  getOragnizations,
  searchOragnizations,
  filterOragnizations,
  updateOrganization,
  getOrganizationsCount
};
